import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map, TileLayer, Polyline, ZoomControl, LayersControl } from 'react-leaflet';
import RideMarker from './RideMarker';
import PointMarker from './PointMarker';
import { byPenalty, coupleEvents } from '../../utils/helpers';
import L from 'leaflet';
import 'leaflet.polyline.snakeanim';

export default class JourneyMap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: null,
        };
    }
    getBounds(points) {
        if (points.length) return new L.Polyline(points, { weight: 6 }).getBounds();
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.draggingDisabled !== this.props.draggingDisabled) {
            if (nextProps.draggingDisabled) this.refs.map.leafletElement.dragging.disable();
            if (!nextProps.draggingDisabled) this.refs.map.leafletElement.dragging.enable();
        }
        if (nextProps.scrollDisabled !== this.props.scrollDisabled) {
            if (nextProps.scrollDisabled) this.refs.map.leafletElement.scrollWheelZoom.disable();
            if (!nextProps.scrollDisabled) this.refs.map.leafletElement.scrollWheelZoom.enable();
        }
    }
    renderEventMarkers() {
        const { journey } = this.props;
        if (journey) {
            const events = journey.journey.events.filter(e => e.penalties).filter(byPenalty);

            return (
                <div>
                  <PointMarker type="start" journey={journey} />
                  <PointMarker type="end" journey={journey} />
                    {
                        this.props.needEventsRender && events && events.map(event => (<RideMarker
                            key={event.id}
                            event={event}
                            activeTooltip={this.state.active}
                            onTooltipRendered={(tooltip) => { this.setState({ active: tooltip }); }}
                            onAppealClick={() => { this.props.onAppealClick(event); }}
                        />))
                    }
                </div>
            );
        }
        return <div />;
    }

    renderSpeedingPolyline = () => {
        const { journey } = this.props;
        if (journey) {
            const polylines =
                coupleEvents(journey.journey.events)
                    .map(events => events.map(e => (new L.LatLng(e.lat / 10000000, e.lon / 10000000))))
                    .map((points, i) => <Polyline key={i} color="#ff2020" ref={`polyline${i}`} positions={points} />);

            return (
                <div>
                    {polylines}
                </div>
            );
        }
        return <div />;
    };

    render() {
        const { journey, currentDeviceStats, scrollDisabled, draggingDisabled, needEventsRender, needSpeedingsRender, renderChildren, doubleClickZoomDisabled } = this.props;
        let position = currentDeviceStats.lat ? [currentDeviceStats.lat / 10000000, currentDeviceStats.lon / 10000000] : [0, 0];
        if (journey) position = [journey.journey.stat.startLat / 10000000, journey.journey.stat.startLon / 10000000];
        const points = journey ? journey.journey.events.map(event => new L.LatLng(event.lat / 10000000, event.lon / 10000000)) : [];
        const tileUrl = L.Browser.retina
            ? 'https://tiles.corp.smartdriving.io/v1/map/{z}/{x}/{y}@2x.png'
            : 'https://tiles.corp.smartdriving.io/v1/map/{z}/{x}/{y}.png';
        
        const { BaseLayer } = LayersControl;
        
        return (
            journey && journey.journey.stat.distance > 0
                ? <Map
                ref="map"
                bounds={this.getBounds(points)}
                center={position}
                style={{ height: '100%' }}
                zoom={14}
                zoomControl={false}
                doubleClickZoom={!doubleClickZoomDisabled}
                scrollWheelZoom={!scrollDisabled}
                dragging={!draggingDisabled}
                attributionControl={false}
            >
              {renderChildren && this.props.children}
              <LayersControl position="bottomleft">
                <BaseLayer checked name="SDL Map">
                  <TileLayer detectRetina url={tileUrl} />

                </BaseLayer>
                <BaseLayer name="OSM Map">
                  <TileLayer
                      attribution="&amp;copy <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                      url="https://a.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />
                </BaseLayer>

                <Polyline color="#5bdb83" ref="polyline" positions={points} />
                  { !!this.props.zoomControl && <ZoomControl position="bottomright" style={{ right: 355 }} /> }
                  {this.renderEventMarkers()}
                  {needEventsRender || needSpeedingsRender ? this.renderSpeedingPolyline() : null}
                  

              </LayersControl>
            </Map>
                : <Map
                ref="map"
                center={position}
                style={{ height: '100%' }}
                zoom={10}
                zoomControl={false}
                doubleClickZoom={!doubleClickZoomDisabled}
                scrollWheelZoom={!scrollDisabled}
                dragging={!draggingDisabled}
                attributionControl={false}
            >
              <LayersControl position="bottomleft">
                <BaseLayer checked name="SDL Map">
                  <TileLayer detectRetina url={tileUrl} />

                </BaseLayer>
                <BaseLayer name="OSM Map">
                  <TileLayer
                      attribution="&amp;copy <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                      url="https://a.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />
                </BaseLayer>
                <Polyline color="#5bdb83" ref="polyline" positions={points} />
                  { !!this.props.zoomControl && <ZoomControl position="bottomright" style={{ right: 355 }} /> }
                  {this.renderEventMarkers()}
                  {needEventsRender || needSpeedingsRender ? this.renderSpeedingPolyline() : null}
                  {renderChildren && this.props.children}
              </LayersControl>
            </Map>
        );
    }
}

JourneyMap.propTypes = {
    journey: PropTypes.object,
    currentDeviceStats: PropTypes.object,
    scrollDisabled: PropTypes.bool,
    draggingDisabled: PropTypes.bool,
    doubleClickZoomDisabled: PropTypes.bool,
    zoomControl: PropTypes.bool,
    needEventsRender: PropTypes.bool,
    needSpeedingsRender: PropTypes.bool,
    isPreviewing: PropTypes.bool,
    renderChildren: PropTypes.bool,
    children: PropTypes.element,
    onAppealClick: PropTypes.func,
};

JourneyMap.defaultProps = {
    renderChildren: false,
    onAppealClick: () => {},
};



// WEBPACK FOOTER //
// ./src/components/JourneyMap/index.js